import { useMediaQuery, useViewportSize } from "@mantine/hooks";

const mdBreakpoint = 768;
const lgBreakpoint = 1200;

export const useResponsive = () => {
  // 表の列数計算などで実際の幅が必要な画面があるため、幅はそのまま返す
  const { width } = useViewportSize();

  // CSS と同じメディアクエリで判定する。
  // window.innerWidth は整数に丸められるため、ブラウザのズームで画面幅が小数に
  // なったときに CSS の判定とずれ、境界の幅で表示が崩れる。
  //
  // 初期値はどちらも false にする。サーバー側は画面幅が分からないため、
  // モバイル向けではない状態で描画され、ブラウザ側の最初の描画も同じ状態に
  // なる（食い違うと画面表示のエラーになる）。実際の画面幅による判定は
  // そのあと反映される。
  const isMobile = useMediaQuery(`(max-width: ${mdBreakpoint}px)`, false);
  const isDesktop = useMediaQuery(`(min-width: ${lgBreakpoint}px)`, false);
  const isTablet = !isMobile && !isDesktop;

  return {
    isMobile,
    isTablet,
    isDesktop,
    width,
  };
};
